import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import './AccountMenu.scss';
import { useAuth } from '../../hooks/Services/AuthContext';
import Cookies from 'js-cookie';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from '@mui/material';

const AccountMenu = () => {
    // Try to get user object from cookies, safely.
    let user = null;
    try {
        const userCookie = Cookies.get('user');
        if (userCookie) {
            user = JSON.parse(userCookie);
        }
    } catch (err) {
        user = null; // Ignore parsing errors or wrong cookies.
    }

    const { logout } = useAuth();
    const intl = useIntl();
    const [open, setOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="account-wrapper" ref={menuRef}>
            <Button
                sx={{ color: 'text.primary', minWidth: 0, padding: '8px' }}
                aria-label={intl.formatMessage({ id: "account", defaultMessage: "Konto" })}
                onClick={() => setOpen(prev => !prev)} className="account-button">
                <PersonOutlineOutlinedIcon />
            </Button>

            {open && (
                <div className="account-dropdown">
                    {user ? ( // IF LOGGED IN
                        <>
                            <p><strong>{user.username || <FormattedMessage id="profile" />}</strong></p>
                            <p>{user.email}</p>
                            <Link className="profile" to="/profile"> <FormattedMessage id="profile" /></Link>
                            <div className="divider" />
                            <Link className="logout" onClick={() => {
                                setOpen(false);
                                logout();
                            }}>
                                <FormattedMessage id="logout" />
                            </Link>
                        </>
                    ) : ( // IF NOT LOGGED IN
                        <>
                            <p><FormattedMessage id="account_not_logged_in" /></p>
                            <p><FormattedMessage id="account_login_prompt" /></p>
                            <Link className="login" to="/login"> <FormattedMessage id="login" /></Link>
                            <Link className="register" to="/register" ><FormattedMessage id="register" /></Link>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default AccountMenu;
